/**
 * Get the appropriate API URL for both local development and production
 * @param {string} endpoint - The API endpoint (e.g., '/api/heygen/get-access-token')
 * @returns {string} - The full API URL for production or relative path for local
 */
export const getApiUrl = (endpoint) => {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  
  // For local development (no REACT_APP_BACKEND_URL set), use relative paths
  // For production (REACT_APP_BACKEND_URL set), use full URLs
  return backendUrl ? `${backendUrl}${endpoint}` : endpoint;
};

/**
 * Environment configuration helper
 */
export const config = {
  isProduction: !!process.env.REACT_APP_BACKEND_URL,
  backendUrl: process.env.REACT_APP_BACKEND_URL || '',
  heygenBaseUrl: process.env.REACT_APP_HEYGEN_BASE_URL || 'https://api.heygen.com'
}; 